export default "__VITE_ASSET__DrhAAnqK__"